import Checkbox from './Checkbox.tsx';
import classnames from '../utils/classnames.tsx';
import * as React from 'react';

const CheckboxGroup = ({
    options,
    value,
    onValueChange,
}: {
    options: { value: string; label: React.ReactNode; disabled?: boolean }[];
    value: string[];
    onValueChange: (value: string[]) => void;
}) => {
    return (
        <div className="flex flex-col">
            {options.map((option) => (
                <label
                    key={option.value}
                    className={classnames(
                        'flex gap-2 items-center group p-1 rounded transition-colors',
                        option.disabled
                            ? 'cursor-not-allowed'
                            : 'hover:bg-surface-medium focus-within:bg-surface-medium'
                    )}
                >
                    <Checkbox
                        checked={value.includes(option.value)}
                        onChange={(e) => {
                            if (e.target.checked) {
                                onValueChange([...value, option.value]);
                            } else {
                                onValueChange(value.filter((v) => v !== option.value));
                            }
                        }}
                        disabled={!!option.disabled}
                    />

                    <span
                        className={classnames('text-sm', option.disabled ? 'text-content-weak' : 'text-content-strong')}
                    >
                        {option.label}
                    </span>
                </label>
            ))}
        </div>
    );
};

export default CheckboxGroup;
